import { render } from "./ActivityFeedContent.vue?vue&type=template&id=11b3945f"
import script from "./ActivityFeedContent.vue?vue&type=script&lang=js"
export * from "./ActivityFeedContent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__